export const lazyloadObserver = () => {


    var settings = {
        threshold       : 0,
        failure_limit   : 0,
        event           : "scroll",
        effect          : "show",
        container       : window,
        data_attribute  : "original",
        data_alt        : "alt",
        skip_invisible  : false,
        appear          : null,
        load            : null,
        carousel        :false,
        placeholder : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAdCAYAAABfeMd1AAAAJklEQVR42u3NoQEAAAwCIP9/2l1hGoFM2mYtEolEIpFIJBLJ0+QACkl2+ul+UF0AAAAASUVORK5CYII="
    };

    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy-img"));

    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        var counter = 0;
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                let lazyImage = entry.target;
                // console.log(lazyImage)
                var thisIsInvisibleSwatch = false;
                if ($(lazyImage).parent().is('[aria-hidden="true"]') 
                    && !$(lazyImage).parent().prev().is('[aria-hidden="false"]')) {
                        thisIsInvisibleSwatch = true;
                    }
                if ((settings.skip_invisible && !$(lazyImage).is(":visible")) 
                    || thisIsInvisibleSwatch || (!$(lazyImage).is('img') && !$(lazyImage).is(':visible'))) {
                        return;
                    }
                if ($.abovethetop(lazyImage, settings) ||
                    $.leftofbegin(lazyImage, settings)) {
                    /* Nothing. */
                } else if (!$.belowthefold(lazyImage, settings)) {
                // $(lazyImage).trigger("appear");
                /* if we found an image we'll load, reset the counter */
                counter = 0;
                } else {
                    if (++counter > settings.failure_limit) {
                        return false;
                    }
                }
                
                const original = lazyImage.getAttribute('data-original')
                lazyImage.src = original;
                lazyImage.classList.remove("lazy-img");
                lazyImageObserver.unobserve(lazyImage);
            }
        });
    });

    lazyImages.forEach(function(lazyImage) {
        lazyImageObserver.observe(lazyImage);
    });

}
